import {
  LOGO_TYPE_SMINEX_CLUB,
  COMPONENT_TYPE_IMAGE,
  COMPONENT_TYPE_TITLE,
  COMPONENT_TYPE_LOGO,
  LOGO_TYPE_SMINEX,
  IMAGE_16X9,
  TITLE_1,
  TITLE_2,
  LOGO_TYPE_SMINEX_PERFECTIONISTS,
  ElementsTemplate,
  ElementTypeEnum,
  FormComponent,
  FormData,
  FormLogo,
} from '@entities/leadCollector';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { colors } from '@shared/tokens/colors.stylex';
import { ImageIcon } from '@shared/assets/icons';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface SidebarRenderContentProps {
  elementType: ElementTypeEnum;
  elements: ElementsTemplate[];
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}

export const SidebarRenderContent = ({ elementType, elements, setFormData }: SidebarRenderContentProps) => {
  const handleLogoClick = (logoId: number) => {
    const newComponent: FormComponent = {
      id: String(logoId),
      instanceId: `logo-${Date.now()}`,
      type: COMPONENT_TYPE_LOGO,
      properties: {},
    };

    setFormData((prev) => ({
      components: [...prev.components, newComponent],
    }));
  };

  const handleImageClick = (imageId: number) => {
    const newComponent: FormComponent = {
      id: String(imageId),
      instanceId: `image-${Date.now()}`,
      type: COMPONENT_TYPE_IMAGE,
      properties: {},
    };

    setFormData((prev) => ({
      components: [...prev.components, newComponent],
    }));
  };

  const handleTitleClick = (titleId: number) => {
    const newComponent: FormComponent = {
      id: String(titleId),
      instanceId: `title-${Date.now()}`,
      type: COMPONENT_TYPE_TITLE,
      properties: { headerTitle: '' },
    };

    setFormData((prev) => ({
      components: [...prev.components, newComponent],
    }));
  };

  if (elementType === ElementTypeEnum.LOGO) {
    if (!elements.length) {
      return null;
    }

    return (
      <div {...stylex.props(styles.logoContainer)}>
        {elements.map((element) => {
          if (element.id === LOGO_TYPE_SMINEX) {
            return (
              <UnstyledButton key={element.id} onClick={() => handleLogoClick(element.id)}>
                <div {...stylex.props(styles.logoItemContainer)}>
                  <FormLogo type={LOGO_TYPE_SMINEX} color="currentColor" width={61} height={30} />
                </div>
              </UnstyledButton>
            );
          }

          if (element.id === LOGO_TYPE_SMINEX_CLUB) {
            return (
              <UnstyledButton key={element.id} onClick={() => handleLogoClick(element.id)}>
                <div {...stylex.props(styles.logoItemContainer)}>
                  <FormLogo type={LOGO_TYPE_SMINEX_CLUB} color="currentColor" width={100} height={30} />
                </div>
              </UnstyledButton>
            );
          }

          if (element.id === LOGO_TYPE_SMINEX_PERFECTIONISTS) {
            return (
              <UnstyledButton key={element.id} onClick={() => handleLogoClick(element.id)}>
                <div {...stylex.props(styles.logoItemContainer, styles.logoPerfectionists)}>
                  <FormLogo type={LOGO_TYPE_SMINEX_PERFECTIONISTS} color="currentColor" />
                </div>
              </UnstyledButton>
            );
          }
        })}
      </div>
    );
  }

  if (elementType === ElementTypeEnum.IMAGE) {
    if (!elements.length) {
      return null;
    }

    return (
      <div>
        {elements.map((element) => {
          if (element.id === IMAGE_16X9) {
            return (
              <UnstyledButton key={element.id} onClick={() => handleImageClick(element.id)}>
                <div {...stylex.props(styles.imageContainer)}>
                  <div {...stylex.props(styles.imageItem)}>
                    <ImageIcon color={colors.accentIcon} width="20" height="20" />
                    <span {...stylex.props(styles.imageText)}>16х9</span>
                  </div>

                  <span {...stylex.props(styles.imageDescription)}>Изображение-обложка</span>
                </div>
              </UnstyledButton>
            );
          }
        })}
      </div>
    );
  }

  if (elementType === ElementTypeEnum.TITLE) {
    if (!elements?.length) {
      return null;
    }

    return (
      <div {...stylex.props(styles.titleContainer)}>
        {elements.map((element) =>
          element.id === TITLE_1 ? (
            <UnstyledButton key={element.id} onClick={() => handleTitleClick(element.id)}>
              <div {...stylex.props(styles.titleOne)}>Заголовок H1</div>
            </UnstyledButton>
          ) : (
            element.id === TITLE_2 && (
              <UnstyledButton key={element.id} onClick={() => handleTitleClick(element.id)}>
                <div {...stylex.props(styles.titleTwo)}>Заголовок H2</div>
              </UnstyledButton>
            )
          )
        )}
      </div>
    );
  }
};
